angular.module('impactx.panel').controller('SupplierPanelCtrl', ['$scope','$mdDialog', '$controller', '$context',
    'TranslationService', 'ThemeWorldService', 'AppConfiguration', 'ProductViewService', 'SearchFilterStorage', '$routeParams', '$redirect', SupplierPanelCtrl]);

function SupplierPanelCtrl($scope, $mdDialog, $controller, $context, TranslationService, ThemeWorldService, AppConfiguration, ProductViewService, SearchFilterStorage, $routeParams, $redirect) {

    angular.extend(this, $controller('PanelCtrl'));

    var self = this,
        translation;

    self.link = function() {
        if ($routeParams.useSetFilterList && SearchFilterStorage.getCurrentFilter()) {
            var filter = JSON.parse(JSON.stringify(SearchFilterStorage.getCurrentFilter()));
            filter.supplierId = {value: $scope.supplier.id};
            filter.dialogFilter = "supplier";
            SearchFilterStorage.setSupplierFilter($scope.supplier.id, filter);
            $redirect.redirectTo(null, "supplier/" + $scope.supplier.id + "/true");
        }
        else {
            if ($scope.currentFilter) {
                var filter = JSON.parse(JSON.stringify($scope.currentFilter));
                filter.supplierId = {value: $scope.supplier.id};
                filter.dialogFilter = "supplier";
                filter.productPageNumber = 0;
                SearchFilterStorage.setSupplierFilter($scope.supplier.id, filter);
            }
            $redirect.redirectTo(null, "/supplier/" + $scope.supplier.id + ($scope.currentFilter ? "/true" : ""));
        }
    };

    self.trns = {
        addToThemeWorld: TranslationService.get('addToThemeWorld'),
        removeFromThemeWorld: TranslationService.get('removeFromThemeWorld'),
        addToProductView: TranslationService.get('addToProductView'),
        removeFromProductView: TranslationService.get('removeFromProductView')
    };

    self.showPanelLabel = AppConfiguration.get('showPanelLabels');

    self.addToThemeWorld = function($event) {
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ThemeWorldService.addSuppliersToThemeWorld([$scope.supplier]);
    };

    self.removeFromThemeWorld = function($event) {
        var supplierIds = [];
        $scope.supplier.tw.add = true;
        $scope.supplier.tw.remove = false;
        supplierIds.push($scope.supplier.id);
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ThemeWorldService.removeSuppliersFromThemeWorld($context.hasActiveThemeWorld.id, supplierIds);
    };

    self.addToProductView = function($event) {
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ProductViewService.addSuppliersToProductView([$scope.supplier]);
    };

    self.removeFromProductView = function($event) {
        var supplierIds = [];
        $scope.supplier.pv.add = true;
        $scope.supplier.pv.remove = false;
        supplierIds.push($scope.supplier.id);
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ProductViewService.removeSuppliersFromProductView($context.hasActiveProductView.id, supplierIds);
    };

    if ($scope.withAdditionalInfo
        && (($scope.supplier.outlets && $scope.supplier.outlets.length > 0)
        || ($scope.supplier.contractsInfo && $scope.supplier.contractsInfo.length > 0)
        || ($scope.supplier.outletsInfo && $scope.supplier.outletsInfo.length > 0)))
    {
        $scope.showAdditionalInfoFunc = function (params, ev)
        {
            $mdDialog.show({
                templateUrl: "modules/lot/templates/supplierinfo.html",
                controller: "LotOutletsCtrl",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    outlets: $scope.supplier.outlets,
                    outletsInfo: $scope.supplier.outletsInfo,
                    contractsInfo: $scope.supplier.contractsInfo,
                    outletsHeader: $scope.outletHeader,
                    outletsInfoHeader: $scope.outletsInfoHeader,
                    conditionsHeader: $scope.conditionsHeader,
                    cancelHeader: $scope.cancelHeader,
                    header: $scope.infoHeader,
                    cancelConditionsHeader: $scope.trns.cancelConditionsHeader,
                    cancelSingleConditionHeader: $scope.trns.cancelSingleConditionHeader
                }
            })
        };
        $scope.options = [{label: $scope.trns.showAdditionalInfo, func: $scope.showAdditionalInfoFunc}];
    }
}
